import { getAvailableTests } from '@ott/ab-test';

const availableTests: string[] = getAvailableTests();

// https://onetwotripdev.atlassian.net/browse/FI-1021
// Установка мобильного приложения
const META_WEB_BANNER = 'm38_b';

export const checkIsMetaWebBanner = () => availableTests.includes(META_WEB_BANNER);
